import React from "react";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { LOADER_TYPE, LOADER_SIZE, LOADER_BACKGROUND_COLOR } from "./constant";
import {
    OverLayLoader,
    OverLayLoaderContent,
    OverLayLoaderText,
    OverLayLoaderText2,
} from "./styled";

interface FullPageLoaderProps {
    heading?: string;
    description?: string;
}

const FullPageLoader = ({ heading, description }: FullPageLoaderProps) => {
    return (
        <OverLayLoader role="status" aria-live="polite" aria-busy="true">
            <Loader
                type={LOADER_TYPE}
                size={LOADER_SIZE}
                backgroundColor={LOADER_BACKGROUND_COLOR}
            />
            <OverLayLoaderContent>
                {heading && (
                    <OverLayLoaderText variant="V2.heading1.neutral.black">
                        {heading}
                    </OverLayLoaderText>
                )}
                {description && (
                    <OverLayLoaderText2 variant="V2.body2.neutral.medium">
                        {description}
                    </OverLayLoaderText2>
                )}
            </OverLayLoaderContent>
        </OverLayLoader>
    );
};

export default FullPageLoader;
